import { useState, useEffect, useCallback } from 'react'
import { useManualQuery } from 'graphql-hooks'
import { getLeaveTypesList } from '../../../graphql/custom-queries'
import { IGetLeaveTypesList } from '../../../types/leave-types'

interface UseLeaveTypesReturn {
  leaveTypes: IGetLeaveTypesList['getLeaveTypeList']
  loading: boolean
  refetch: () => Promise<void>
}

/**
 * Custom hook for fetching leave types
 * Filters to only active and non-deleted leave types
 */
export const useLeaveTypes = (): UseLeaveTypesReturn => {
  const [leaveTypes, setLeaveTypes] = useState<IGetLeaveTypesList['getLeaveTypeList']>([])
  const [loading, setLoading] = useState(true)
  const [getLeaveTypesQuery] = useManualQuery<IGetLeaveTypesList>(getLeaveTypesList)

  const fetchLeaveTypes = useCallback(async () => {
    try {
      setLoading(true)
      const response = await getLeaveTypesQuery()
      if (!response.error && response.data?.getLeaveTypeList) {
        // Filter to only active and non-deleted leave types
        const filteredLeaveTypes = response.data.getLeaveTypeList.filter((lt) => lt.isActive && !lt.deleted)
        setLeaveTypes(filteredLeaveTypes)
      }
    } catch (error) {
      console.error('Error fetching leave types:', error)
    } finally {
      setLoading(false)
    }
  }, [getLeaveTypesQuery])

  useEffect(() => {
    fetchLeaveTypes()
  }, [fetchLeaveTypes])

  return {
    leaveTypes,
    loading,
    refetch: fetchLeaveTypes,
  }
}
